const META_PIXEL_ID = "972995622220401";

export const initMetaPixel = () => {
  if (window.fbq) {
    window.fbq("track", "PageView");
    return;
  }

  window._fbq = window.fbq = function () {
    window.fbq.callMethod
      ? window.fbq.callMethod.apply(window.fbq, arguments)
      : window.fbq.queue.push(arguments);
  };

  window.fbq.push = window.fbq;
  window.fbq.loaded = true;
  window.fbq.version = "2.0";
  window.fbq.queue = [];

  const script = document.createElement("script");
  script.async = true;
  script.src = "https://connect.facebook.net/en_US/fbevents.js";

  const firstScript = document.getElementsByTagName("script")[0];
  firstScript.parentNode.insertBefore(script, firstScript);

  window.fbq("init", META_PIXEL_ID);
  window.fbq("track", "PageView");
};

export const trackPurchase = (category) => {
  if (!window.fbq) return;

  window.fbq("track", "Purchase", {
    value: 1,
    currency: "EUR",
    content_category: category,
  });
};